// Timeout in ms
const defaultTimeOut = 500;
export class Utils {
  static sendAnalyticsEvent = (thdAnalyticsEvent, timeOut = () => (defaultTimeOut)) => new Promise((resolve) => {
    if (typeof window === 'undefined') {
      resolve();
      return;
    }

    if (!window.digitalData.event) {
      window.digitalData.event = [];
    }
    window.digitalData.event.push(thdAnalyticsEvent);
    window.setTimeout(resolve(), timeOut);
  });
}
const exportObj = {
  Utils,
};

export default exportObj;
